import CreateLoanOfficer from './CreateLoanOfficer';

export default CreateLoanOfficer;
